exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n/*.md-table-card {*/\n/*width: 100%;*/\n/*}*/\n.strikethrough[data-v-6f39db9a] {\n  text-decoration-line: line-through;\n}\n.unavailable[data-v-6f39db9a] {\n  font-style: italic;\n  color: #7d7d7d;\n}\n", ""]);

